import React from "react";
import './ConfirmationModal.css';

export default function ConfirmationModal({
  open,
  onClose,
  onConfirm,
  filterName = "",
  type = "confirm",
  message,
  title,
  subMessage, // <-- add this
  confirmText = "Delete", // <-- add this
  cancelText = "Cancel",  // <-- add this
}) {
  if (!open) return null;

  const isError = type === "error";
  const modalTitle = title || (isError ? "Error" : "Warning");
  const modalMessage =
    message ||
    (isError
      ? "Something went wrong. Please reset your filter and proceed."
      : (
        <>Are you sure you want to delete <b>{filterName}</b>?</>
      )
    );

  return (
    <div className="cfm-modal-overlay">
      <dialog open className={`cfm-modal${isError ? " cfm-modal-error" : ""}`}>
        <button className="cfm-modal-close" onClick={onClose} title="Close">
          ×
        </button>
        <div className="cfm-modal-content">
          <div className={`cfm-modal-icon${isError ? " cfm-modal-icon-error" : ""}`}>
            {/* SVG ICON */}
            {isError ? (
              // Error icon (Red)
              <svg width="48" height="48" viewBox="0 0 48 48">
                <g>
                  <polygon
                    points="24,6 46,42 2,42"
                    fill="#fff3f3"
                    stroke="#d32f2f"
                    strokeWidth="2"
                  />
                  <polygon
                    points="24,8.7 43.1,40 4.9,40"
                    fill="#fff"
                    stroke="none"
                  />
                  <circle cx="24" cy="33" r="2" fill="#d32f2f" />
                  <rect x="22.6" y="18" width="2.8" height="10" rx="1.3" fill="#d32f2f" />
                </g>
              </svg>
            ) : (
              // Warning icon (Orange)
              <svg width="48" height="48" viewBox="0 0 48 48">
                <g>
                  <polygon
                    points="24,6 46,42 2,42"
                    fill="#fff3e4"
                    stroke="#ff9800"
                    strokeWidth="2"
                  />
                  <polygon
                    points="24,8.7 43.1,40 4.9,40"
                    fill="#fff"
                    stroke="none"
                  />
                  <circle cx="24" cy="33" r="2" fill="#ff9800" />
                  <rect x="22.6" y="18" width="2.8" height="10" rx="1.3" fill="#ff9800" />
                </g>
              </svg>
            )}
          </div>
          <div className="cfm-modal-main">
            <div className={`cfm-modal-title${isError ? " cfm-modal-title-error" : ""}`}>{modalTitle}</div>
            <div className={`cfm-modal-body${isError ? " cfm-modal-body-error" : ""}`}>
              {modalMessage}
            </div>
            {/* Only show subMessage if provided */}
            {subMessage && <div className="cfm-modal-desc">{subMessage}</div>}
            {!isError && (
              <div className="cfm-modal-actions">
                <button className="cfm-modal-btn cfm-cancel" onClick={onClose}>
                  {cancelText}
                </button>
                <button className="cfm-modal-btn cfm-delete" onClick={onConfirm}>
                  {confirmText}
                </button>
              </div>
            )}
          </div>
        </div>
      </dialog>
    </div>
  );
}